import { createTheme } from '@mui/material/styles';

const getTheme = ({
  themeMode,
}) => createTheme({
  palette: {
    mode: themeMode,
    ...(themeMode === 'light'
      ? {
        primary: {
          main: '#121214',
        },
        secondary: {
          main: '#FF473D',
        },
      }
      : {}),
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: 12,
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: '0.75rem',
          padding: '4px',
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          fontSize: '0.75rem',
        },
      },
    },
  },
});

export default getTheme;
